import { render } from "./WidgetError.vue?vue&type=template&id=acb6a886&scoped=true"
import script from "./WidgetError.vue?vue&type=script&lang=js"
export * from "./WidgetError.vue?vue&type=script&lang=js"

import "./WidgetError.vue?vue&type=style&index=0&id=acb6a886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb6a886"]])

export default __exports__